import React, { ReactElement } from 'react';

import { DownloadsContentListProps, DownloadsScreen } from '@bighealth/types';

import { useParams } from 'cross-platform/react-router';

import {
  Content,
  ContentTitle,
  ContentTitleBlock,
  SkeletonOuterContainerAnimated,
} from '../components';
import { isNonEmptyPageData } from '../components/helpers';

import { DownloadsContentEntry } from './DownloadsContentEntry';
import { DownloadsScreenParams } from './types';

export const DownloadsContent = ({
  content,
  isLoading,
}: {
  isLoading?: boolean;
  content?: DownloadsScreen;
}): ReactElement | null => {
  const { page } = useParams<DownloadsScreenParams>();
  if (isLoading) {
    return <SkeletonOuterContainerAnimated />;
  }
  if (typeof content === 'undefined') {
    return null;
  }
  if (!isNonEmptyPageData(content)) {
    return null;
  }
  const selectedItem = content.find(({ slug }) => slug === page);

  return (
    <Content>
      <ContentTitleBlock>
        <ContentTitle>{selectedItem?.title}</ContentTitle>
      </ContentTitleBlock>
      {(selectedItem?.content as DownloadsContentListProps[]).map(
        (props, index) => (
          <DownloadsContentEntry {...props} key={index} />
        )
      )}
    </Content>
  );
};
